const faqs = [
  {
    q: '51吃瓜官网的内容来源是否可靠？',
    a: '我们的内容全部来自专业团队的原创调查和多源交叉验证。每一篇爆料在发布前，都需要经过编辑、审核、事实核查三道流程。我们与圈内多个可靠信源保持长期合作关系，确保信息的真实性和时效性。',
  },
  {
    q: '51吃瓜莫里秀是独立栏目吗？',
    a: '是的，51吃瓜莫里秀是我们旗下的王牌调查栏目，专注于深度娱乐调查报道。莫里秀团队由资深媒体人和调查记者组成，以专业的手法追踪娱乐圈重大事件背后的真相，在读者中享有极高的口碑。',
  },
  {
    q: '如何向51吃瓜投稿或提供爆料线索？',
    a: '我们非常欢迎读者提供爆料线索！您可以通过我们的爆料邮箱 hello@pxkblfc.cn 或本页面的在线留言表单提交信息。所有爆料人的身份信息将被严格保密，未经本人同意绝不对外公开。',
  },
  {
    q: '网站的内容更新频率是怎样的？',
    a: '我们保持7x24小时全天候更新，每天至少发布5-8篇原创内容。突发重大事件时，我们会启动应急报道机制，确保第一时间将最新资讯呈现给读者。',
  },
  {
    q: '51吃瓜官网是否收费？',
    a: '目前51吃瓜官网的所有内容都是免费向公众开放的，无需注册即可浏览。我们通过品牌广告和商务合作实现运营收入，未来也不计划对内容阅读进行收费。吃瓜，本来就是每个人的权利！',
  },
];

export default function FAQSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-label font-semibold text-secondary-600 bg-secondary-100 rounded-full">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            你可能想知道的
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于51吃瓜官网，这里有你关心的所有答案
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 md:px-6 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-arrow-down-s-line text-foreground-400 text-lg transition-transform duration-200 group-open:rotate-180"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-4 pt-0">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}